/**
 * RTK Query tag type constants.
 * Use these constants instead of string literals for type safety and consistency.
 */

export const Tag = {
  AuthStatus: "AuthStatus",
  CurrentUser: "CurrentUser",
  MyProjects: "MyProjects",
  Repo: "Repo",
  Relays: "Relays",
  SpendCap: "SpendCap",
  IrohNodes: "IrohNodes",
} as const

export type TagType = (typeof Tag)[keyof typeof Tag]
